import type { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'

import type { FormValues } from '../../types'
import { getCommonFieldsPayload } from './getCommonFieldsPayload'

type Payload = Parameters<typeof MembershipsCreatorV2ApiClient.updateLiveStreamPost>[1]

export const getUpdateLiveStreamPostPayload = (values: FormValues): Payload => {
  const commonPayload = getCommonFieldsPayload(values)

  return {
    post: {
      title: commonPayload.attributes.core.title,
      description: commonPayload.attributes.core.description,
      startsAt: values.liveStreamStartDate!,
      tags: commonPayload.attributes.core.tags,
      series: values.videoSeries,
    },
    access: commonPayload.access,
    notifications: commonPayload.notifications,
    imageResource: {
      type: 'Keep',
    },
  }
}
